import React, { useState } from 'react';
import {
  useResponsiveParams,
  Text,
  useQuantaFormikContext,
  MixedGridGroup,
  NotificationList,
  QuantaForm,
} from 'quanta-ui';
import {useFetchQuery} from 'quanta-flows';
import { useQuery } from '@apollo/client';
import {Loading} from 'quanta-flows/modules/layout';
import {
  CUSTOMER_ORGANISATIONAL_DROPDOWN_DETAIL,
  PINCODE_LOOKUP,
} from '../../queries';

export default function OrganisationCustomerForm({
  buyHealthPolicy,
}) {
  const { values } = useQuantaFormikContext();
  const [alerts, setAlerts] = useState([]);
  const [loadingPermCustAddr, setLoadingPermCustAddr] =
    useState(false);
  const [loadingCommCustAddr, setLoadingCommCustAddr] =
    useState(false);

  const reformData = (val, returnType, isString) => {
    return val && val.toString().trim() !== ''
      ? isString === undefined || isString === true
        ? `${val}`
        : val
      : returnType;
  };

  const fetchQuery = useFetchQuery();

  const { loading, data: dropDownDetails } = useQuery(
    CUSTOMER_ORGANISATIONAL_DROPDOWN_DETAIL,
    {
      fetchPolicy: 'cache-first',
      onError: (err) => {
        setAlerts([
          {
            header: 'No dropdown details',
            id: 1,
            content: (
              <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                <span>{err.message}</span>
              </div>
            ),
            type: 'error',
            timeout: null,
            disableClose: false,
          },
        ]);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      },
    },
  );

  let repeat = useResponsiveParams({ for_mobile: 1, for_desktop: 3 });

  const onPermAddrLookup = async (val, setFieldValue) => {
    if (
      !(
        val.toString().length !== 6 ||
        !val.toString().match(/^[0-9]+$/)
      )
    ) {
      let queryOutput = fetchQuery({
        query: PINCODE_LOOKUP,
        variables: {
          filter: {
          pincode: val,
          },
        },
      });
      try {
        setAlerts([]);
        setLoadingPermCustAddr(true);
        let { data } = await queryOutput;
        setLoadingPermCustAddr(false);
        setFieldValue(
          'proposerDetails.permCityTownVillage',
          data.pincodeInfo.city,
        );
        setFieldValue(
          'proposerDetails.permDistrict',
          data.pincodeInfo.district,
        );
        setFieldValue(
          'proposerDetails.permState',
          data.pincodeInfo.state,
        );
        if (values.proposerDetails.permCommAddressYN) {
          setFieldValue(
            'proposerDetails.commCityTownVillage',
            data.pincodeInfo.city,
          );
          setFieldValue(
            'proposerDetails.commDistrict',
            data.pincodeInfo.district,
          );
          setFieldValue(
            'proposerDetails.commState',
            data.pincodeInfo.state,
          );
        }
      } catch (error) {
        setAlerts([
          {
            header: 'Address fetch failed',
            id: Date.now(),
            content: (
              <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                <span>{error.message}</span>
              </div>
            ),
            type: 'error',
            timeout: null,
            disableClose: false,
          },
        ]);
        setLoadingPermCustAddr(false);
        setFieldValue('proposerDetails.permCityTownVillage', '');
        setFieldValue('proposerDetails.permDistrict', '');
        setFieldValue('proposerDetails.permState', '');
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }
  };

  const onCommAddrLookup = async (val, setFieldValue) => {
    if (
      !(
        val.toString().length !== 6 ||
        !val.toString().match(/^[0-9]+$/)
      )
    ) {
      let queryOutput = fetchQuery({
        query: PINCODE_LOOKUP,
        variables: {
          pincode: val,
        },
      });
      try {
        setAlerts([]);
        setLoadingCommCustAddr(true);
        let { data } = await queryOutput;
        setLoadingCommCustAddr(false);
        setFieldValue(
          'proposerDetails.commCityTownVillage',
          data.pincodeInfo.city,
        );
        setFieldValue(
          'proposerDetails.commDistrict',
          data.pincodeInfo.district,
        );
        setFieldValue(
          'proposerDetails.commState',
          data.pincodeInfo.state,
        );
      } catch (error) {
        setAlerts([
          {
            header: 'Address fetch failed',
            id: Date.now(),
            content: (
              <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                <span>{error.message}</span>
              </div>
            ),
            type: 'error',
            timeout: null,
            disableClose: false,
          },
        ]);
        setLoadingCommCustAddr(false);
        setFieldValue('proposerDetails.commCityTownVillage', '');
        setFieldValue('proposerDetails.commDistrict', '');
        setFieldValue('proposerDetails.commState', '');
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen">
        <Loading />
      </div>
    );
  }

  const { organisationList } = dropDownDetails;

  const data = [
    buyHealthPolicy?.proposerDetails?.id
      ? {
          title: (
            <span className="text-primary break-all">
              {buyHealthPolicy?.proposerDetails?.orgName}
              {','}
              {repeat === 1 ? <br /> : <>&nbsp;</>}
              {buyHealthPolicy?.proposerDetails?.id}{' '}
              <span className="break-normal">
                - Update or confirm details
              </span>
            </span>
          ),
          grid_type: 'data',
          grid_data: [
            {
              label: 'Customer Number',
              text: reformData(
                buyHealthPolicy?.proposerDetails?.id,
                '',
              ),
            },
            {
              label: 'CRN',
              text: reformData(
                buyHealthPolicy?.proposerDetailsMeta?.crn,
                '',
              ),
            },
          ],
        }
      : null,
    {
      title: (
        <span className="text-primary">Organisation Details</span>
      ),
      grid_type: 'input',
      grid_data: [
        {
          type: 'text',
          label: (
            <div>
              Organisation Name <Text severity="error">*</Text>
            </div>
          ),
          name: 'proposerDetails.orgName',
          disabled: buyHealthPolicy?.proposalNumber.length > 0,
        },
        //Organisation Type CHanges
        {
          type: 'select',
          label: (
            <div>
              Organisation Type <Text severity="error">*</Text>
            </div>
          ),
          name: 'proposerDetails.orgType',
          disabled: buyHealthPolicy?.proposalNumber.length > 0,
          data: organisationList
            ? [
                ...organisationList.map((orgType) => {
                  return {
                    label: orgType.value ? orgType.value : '',
                    value: orgType.code ? orgType.code : '',
                  };
                }),
              ]
            : [],
        },
        {
          type: 'text',
          maxLength: 40,
          label: (
            <div>
              Contact Person Name <Text severity="error"></Text>
            </div>
          ),
          name: 'proposerDetails.contactName',
          disabled: buyHealthPolicy?.proposalNumber.length > 0,
        },
      ],
    },
    {
      title: (
        <span className="text-primary">
          Tax Identification Details
        </span>
      ),
      grid_type: 'input',
      grid_data: [
        {
          type: 'text',
          label: (
            <div>
              Registration Number <Text severity="error">*</Text>
            </div>
          ),
          name: 'proposerDetails.regNumber',
          disabled: buyHealthPolicy?.proposalNumber.length > 0,
        },
        {
          type: 'text',
          label: (
            <div>
              TAN Number <Text severity="error"></Text>
            </div>
          ),
          name: 'proposerDetails.tanNumber',
          disabled: buyHealthPolicy?.proposalNumber.length > 0,
          className: 'uppercase',
        },
        {
          type: 'text',
          label: (
            <div>
              GST Number <Text severity="error"></Text>
            </div>
          ),
          name: 'proposerDetails.gstNumber',
          disabled: buyHealthPolicy?.proposalNumber.length > 0,
          className: 'uppercase',
        },
        /*SADivya - CR P2_233 :KYC*/
        {
          type: 'text',
          maxLength: 20,
          label: (
            <div>
              Udyog Aadhaar Number
            </div>
          ),
          name: 'proposerDetails.udyogAadhaarNumber',
          disabled: buyHealthPolicy?.proposalNumber.length > 0,
          onKeyDown: (e) => {
            if(!e.key.match(/^[0-9]+$/) || evt?.key === ' ') {
              e.preventDefault();
            }
          }
        },
        {
          type: 'text',
          maxLength: 21,
          label: (
            <div>
              Certificate of Incorporation <Text severity="error"></Text>
            </div>
          ),
          name: 'proposerDetails.certificateOfInCorporation',
          disabled: buyHealthPolicy?.proposalNumber.length > 0,
        },
        {
          type: 'text',
          label: <div>CKYC ID Number</div>,
          maxLength: 14,
          name: 'proposerDetails.ckycIdNumber',
          disabled: buyHealthPolicy?.proposalNumber.length > 0,
          onKeyDown: (evt) => {
            if (evt?.key === ' ') {
              evt.preventDefault();
            }
          },
        },
        /*EADivya - CR P2_233: KYC*/
        /**SADivya : CR P2_498 - PAN Mandatory */
        {
          type: 'date',
          label: (
            <div>
              Date Of incorporation <Text severity="error"></Text>
            </div>
          ),
          name: 'proposerDetails.dateOfIncorporation',
          disabled: buyHealthPolicy?.proposalNumber.length > 0,
        },
        {
          type: 'text',
          label: (
            <div>
              PAN Card Number <Text severity="error">*</Text>
            </div>
          ),
          name: 'proposerDetails.panNumber',
          className: 'uppercase',
          disabled: buyHealthPolicy?.proposalNumber.length > 0,
        },
        /**SADivya : CR P2_498 - PAN Mandatory */
      ],
    },
    {
      title: (
        <span className="text-primary">
          Permanent Address Details
        </span>
      ),
      grid_type: 'input',
      grid_data: [
        {
          type: 'text',
          label: (
            <div>
              Address Line 1 <Text severity="error">*</Text>
            </div>
          ),
          name: 'proposerDetails.permAddressLine1',
          disabled: buyHealthPolicy?.proposalNumber.length > 0
              ||buyHealthPolicy?.proposerDetails?.id?.length >0, //SADivya : Cr P2_233:KYC
          onDataChange: (val, setFieldValue) => {
            if (values.proposerDetails.permCommAddressYN) {
              setFieldValue('proposerDetails.commAddressLine1', val);
            }
          },
        },
        {
          type: 'text',
          label: (
            <div>
              Address Line 2 <Text severity="error"></Text>
            </div>
          ),
          name: 'proposerDetails.permAddressLine2',
          disabled: buyHealthPolicy?.proposalNumber.length > 0
              ||buyHealthPolicy?.proposerDetails?.id?.length >0, //SADivya : Cr P2_233:KYC
          onDataChange: (val, setFieldValue) => {
            if (values.proposerDetails.permCommAddressYN) {
              setFieldValue('proposerDetails.commAddressLine2', val);
            }
          },
        },
        {
          type: 'text',
          label: (
            <div>
              Address Line 3 <Text></Text>
            </div>
          ),
          name: 'proposerDetails.permAddressLine3',
          disabled: buyHealthPolicy?.proposalNumber.length > 0
          ||buyHealthPolicy?.proposerDetails?.id?.length >0, //SADivya : Cr P2_233:KYC
          onDataChange: (val, setFieldValue) => {
            if (values.proposerDetails.permCommAddressYN) {
              setFieldValue('proposerDetails.commAddressLine3', val);
            }
          },
        },
        {
          type: 'text',
          label: (
            <div>
              Landmark <Text></Text>
            </div>
          ),
          name: 'proposerDetails.permLandmark',
          disabled: buyHealthPolicy?.proposalNumber.length > 0
          ||buyHealthPolicy?.proposerDetails?.id?.length >0, //SADivya : Cr P2_233:KYC
          onDataChange: (val, setFieldValue) => {
            if (values.proposerDetails.permCommAddressYN) {
              setFieldValue('proposerDetails.commLandmark', val);
            }
          },
        },
        {
          type: 'input-lookup',
          size: 'large',
          loading: loadingPermCustAddr,
          onLookup: onPermAddrLookup,
          label: (
            <div>
              Pin Code <Text severity="error">*</Text>
            </div>
          ),
          name: 'proposerDetails.permPincode',
          disabled:
            loadingPermCustAddr ||
            buyHealthPolicy?.proposalNumber.length > 0
            ||buyHealthPolicy?.proposerDetails?.id?.length >0, //SADivya : Cr P2_233:KYC
          onDataChange: (val, setFieldValue) => {
            setFieldValue('proposerDetails.permCityTownVillage', '');
            setFieldValue('proposerDetails.permState', '');
            setFieldValue('proposerDetails.permDistrict', '');
            if (values.proposerDetails.permCommAddressYN) {
              setFieldValue('proposerDetails.commPincode', val);
              setFieldValue(
                'proposerDetails.commCityTownVillage',
                '',
              );
              setFieldValue('proposerDetails.commState', '');
              setFieldValue('proposerDetails.commDistrict', '');
            }
          },
        },
        {
          type: 'text',
          label: (
            <div>
              City/Town/Village <Text severity="error">*</Text>
            </div>
          ),
          name: 'proposerDetails.permCityTownVillage',
          disabled: true,
        },
        {
          type: 'text',
          label: (
            <div>
              District <Text severity="error">*</Text>
            </div>
          ),
          name: 'proposerDetails.permDistrict',
          disabled: true,
        },
        {
          type: 'text',
          label: (
            <div>
              State <Text severity="error">*</Text>
            </div>
          ),
          name: 'proposerDetails.permState',
          disabled: true,
        },
      ],
    },
    {
      title: (
        <span className="text-primary">Communication Address</span>
      ),
      grid_data: values.proposerDetails.permCommAddressYN
        ? [
            {
              type: 'checkbox',
              name: 'proposerDetails.permCommAddressYN',
              disabled:
                loadingPermCustAddr ||
                loadingCommCustAddr ||
                buyHealthPolicy?.proposalNumber.length > 0,
              label:
                'Communication address same as permanent address',
              colSpan: repeat,
            },
          ]
        : [
            {
              type: 'checkbox',
              name: 'proposerDetails.permCommAddressYN',
              disabled:
                loadingPermCustAddr ||
                loadingCommCustAddr ||
                buyHealthPolicy?.proposalNumber.length > 0,
              label:
                'Communication address same as permanent address',
              colSpan: repeat,
              onDataChange: (_, setFieldValue) => {
                setFieldValue(
                  'proposerDetails.commAddressLine1',
                  values.proposerDetails.permAddressLine1,
                );
                setFieldValue(
                  'proposerDetails.commAddressLine2',
                  values.proposerDetails.permAddressLine2,
                );
                setFieldValue(
                  'proposerDetails.commAddressLine3',
                  values.proposerDetails.permAddressLine3,
                );
                setFieldValue(
                  'proposerDetails.commLandmark',
                  values.proposerDetails.permLandmark,
                );
                setFieldValue(
                  'proposerDetails.commPincode',
                  values.proposerDetails.permPincode,
                );
                setFieldValue(
                  'proposerDetails.commCityTownVillage',
                  values.proposerDetails.permCityTownVillage,
                );
                setFieldValue(
                  'proposerDetails.commDistrict',
                  values.proposerDetails.permDistrict,
                );
                setFieldValue(
                  'proposerDetails.commState',
                  values.proposerDetails.permState,
                );
              },
            },
            {
              type: 'text',
              label: (
                <div>
                  Address Line 1 <Text severity="error">*</Text>
                </div>
              ),
              name: 'proposerDetails.commAddressLine1',
              disabled: buyHealthPolicy?.proposalNumber.length > 0,
            },
            {
              type: 'text',
              label: (
                <div>
                  Address Line 2 <Text severity="error"></Text>
                </div>
              ),
              name: 'proposerDetails.commAddressLine2',
              disabled: buyHealthPolicy?.proposalNumber.length > 0,
            },
            {
              type: 'text',
              label: (
                <div>
                  Address Line 3 <Text></Text>
                </div>
              ),
              name: 'proposerDetails.commAddressLine3',
              disabled: buyHealthPolicy?.proposalNumber.length > 0,
            },
            {
              type: 'text',
              label: (
                <div>
                  Landmark <Text></Text>
                </div>
              ),
              name: 'proposerDetails.commLandmark',
              disabled: buyHealthPolicy?.proposalNumber.length > 0,
            },
            {
              type: 'input-lookup',
              size: 'large',
              loading: loadingCommCustAddr,
              onLookup: onCommAddrLookup,
              label: (
                <div>
                  Pin Code <Text severity="error">*</Text>
                </div>
              ),
              name: 'proposerDetails.commPincode',
              disabled:
                loadingCommCustAddr ||
                buyHealthPolicy?.proposalNumber.length > 0,
              onDataChange: (_, setFieldValue) => {
                setFieldValue(
                  'proposerDetails.commCityTownVillage',
                  '',
                );
                setFieldValue('proposerDetails.commState', '');
                setFieldValue('proposerDetails.commDistrict', '');
              },
            },
            {
              type: 'text',
              label: (
                <div>
                  City/Town/Village <Text severity="error">*</Text>
                </div>
              ),
              name: 'proposerDetails.commCityTownVillage',
              disabled: true,
            },
            {
              type: 'text',
              label: (
                <div>
                  District <Text severity="error">*</Text>
                </div>
              ),
              name: 'proposerDetails.commDistrict',
              disabled: true,
            },
            {
              type: 'text',
              label: (
                <div>
                  State <Text severity="error">*</Text>
                </div>
              ),
              name: 'proposerDetails.commState',
              disabled: true,
            },
          ],
    },
    {
      title: <span className="text-primary">Contact Details</span>,
      grid_data: [
        {
          type: 'number',
          label: (
            <div>
              Telephone Number <Text></Text>
            </div>
          ),
          name: 'proposerDetails.phoneNo',
          disabled: buyHealthPolicy?.proposalNumber.length > 0,
        },
        {
          type: 'text',
          maxLength: 10,
          onKeyDown: (evt) => evt.key === 'e' && evt.preventDefault(),
          label: (
            <div>
              Organisation Mobile Number{' '}
              <Text severity="error">*</Text>
            </div>
          ),
          name: 'proposerDetails.mobileNo',
          disabled: buyHealthPolicy?.proposalNumber.length > 0,
        },
        {
          type: 'number',
          label: (
            <div>
              FAX Number <Text></Text>
            </div>
          ),
          name: 'proposerDetails.faxNo',
          disabled: buyHealthPolicy?.proposalNumber.length > 0,
        },
        {
          type: 'number',
          label: (
            <div>
              Alternative Telephone Number <Text></Text>
            </div>
          ),
          name: 'proposerDetails.altPhoneNo',
          disabled: buyHealthPolicy?.proposalNumber.length > 0,
        },
        {
          type: 'text',
          maxLength: 10,
          label: (
            <div>
              Alternative Mobile Number <Text></Text>
            </div>
          ),
          name: 'proposerDetails.altMobileNo',
          disabled: buyHealthPolicy?.proposalNumber.length > 0,
        },
        {
          type: 'email',
          label: (
            <div>
              Organisation Email Id <Text severity="error">*</Text>
            </div>
          ),
          name: 'proposerDetails.emailID',
          disabled: buyHealthPolicy?.proposalNumber.length > 0,
        },
      ],
    },
  ].filter((d) => d !== null);

  const other_props = {
    flow: 'cols',
    repeat,
    gapX: 6,
    gapY: 0,
    spaceY: 2,
    size: 'full',
    titleSeverity: 'info',
    textType: 'normal',
    nullData: () => <Text severity="neutral">Not Captured</Text>,
  };

  return (
    <>
      <QuantaForm>
        <MixedGridGroup {...{ data, ...other_props }} />
      </QuantaForm>
      <div>
        <NotificationList {...{ items: alerts }} />
      </div>
    </>
  );
}
